// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-FlatCheckout__wrapper","container":"c-FlatCheckout__container","price":"c-FlatCheckout__price","buttonWrapper":"c-FlatCheckout__buttonWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/FlatCheckout/FlatCheckout.scss
// module id = 928
// module chunks = 0